import React, { memo, useRef } from 'react';
import { TableCell, Checkbox } from '@material-ui/core';
import { TableSelection as TableSelectionBase } from '@devexpress/dx-react-grid';
import clsx from 'clsx';
import useStyles from './TableSelectCell.styles';
import useIsSomeActionExecuting from '../../../../lowLevel/FormAction/useIsSomeActionExecuting';

const TableSelectCell = ({
  style,
  selected,
  onToggle,
  className,
  forwardedRef,
  colSpan,
}: TableSelectionBase.CellProps & any) => {
  const classes = useStyles();

  const { isSomeActionExecuting } = useIsSomeActionExecuting();

  const checkboxRef = useRef<HTMLButtonElement>(null);

  const handleClick = (e: React.MouseEvent<HTMLTableCellElement>) => {
    e.stopPropagation();

    onToggle();
  };

  return (
    <TableCell
      padding="checkbox"
      style={style}
      ref={forwardedRef}
      onClick={handleClick}
      className={clsx(classes.cell, className)}
      colSpan={colSpan}
    >
      <Checkbox
        ref={checkboxRef}
        className={classes.checkbox}
        disabled={isSomeActionExecuting}
        onMouseDown={(e) => e.stopPropagation()}
        color="primary"
        checked={selected}
      />
    </TableCell>
  );
};

export default memo(
  TableSelectCell,
  (prevProps, nextProps) =>
    prevProps.selected === nextProps.selected &&
    prevProps.colSpan === nextProps.colSpan &&
    prevProps.disabled === nextProps.disabled
);
